import React, { useEffect } from 'react'
import { FaDesktop } from "react-icons/fa";
import { IoPersonCircleSharp } from "react-icons/io5";
import { PiStudentBold } from "react-icons/pi";
import { SiTicktick } from "react-icons/si";

import AOS from "aos";
import "aos/dist/aos.css";

const HomeCounting = () => {

    useEffect(() => {
        AOS.init();
    }, []);


    return (
        <div className='HomeCounting_section'>
            <div className='container-fluid'>
                <div className='HomeCounting_section_title' data-aos="fade-up" data-aos-duration="2000">
                    <h2>Empowering Minds Through Numbers</h2>
                    <p>At Hamo Tech, we pride ourselves on delivering exceptional training programs that empower learners to excel in their careers. Here's what makes us stand out</p>
                </div>
                <div className='row'>
                    <div className='col-sm-6 col-md-6 col-lg-3' data-aos="fade-up" data-aos-duration="1000">
                        <div className='card HC_cards'>
                            <div className='HC_card1'>
                                <div className=' HC_icon'>
                                    <FaDesktop />
                                </div>
                                <div className=' HC_fields'>
                                    <h4>100+</h4>
                                    <p>Online Courses</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-sm-6 col-md-6 col-lg-3' data-aos="fade-up" data-aos-duration="1400">
                        <div className='card HC_cards'>
                            <div className='HC_card2'>
                                <div className=' HC_icon'>
                                    <IoPersonCircleSharp />
                                </div>
                                <div className=' HC_fields'>
                                    <h4>50+</h4>
                                    <p>Professional tutors</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-sm-6 col-md-6 col-lg-3' data-aos="fade-up" data-aos-duration="1800">
                        <div className='card HC_cards'>
                            <div className='HC_card3'>
                                <div className=' HC_icon'>
                                    <PiStudentBold />
                                </div>
                                <div className=' HC_fields'>
                                    <h4>500+</h4>
                                    <p>Online Learners</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-sm-6 col-md-6 col-lg-3' data-aos="fade-up" data-aos-duration="2000">
                        <div className='card HC_cards'>
                            <div className='HC_card4'>
                                <div className=' HC_icon'>
                                    <SiTicktick />
                                </div>
                                <div className=' HC_fields'>
                                    <h4>60+</h4>
                                    <p>Approved courses</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default HomeCounting
